<template>
  <div class="imgBox">
    <div class="rowHead">
      <div class="rowHeadLeft">
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="做单截图" name="a"></el-tab-pane>
          <!-- <el-tab-pane label="常见问题" name="b"></el-tab-pane>-->
        </el-tabs>
      </div>
      <div class="rowHeadRight">
        <div class="colHeadItem colHeadItemDesc">
          共助力{{ total || 0 }}刀，可左右滑动查看
        </div>
      </div>
    </div>

    <div ref="box" class="middleBox">
      <div v-if="!listData.length">
        <el-empty description="当前订单无照片,请等一会再来看看哦！"></el-empty>
      </div>
      <el-row v-else :gutter="2" class="rowBox" type="flex">
        <el-col v-for="(item, i) in listData" :key="i" :sm="4" :xs="12">
          <div class="mItemBox">
            <div class="swiperBox">
              <div class="swiper-wrapper">
                <div v-for="(img, index) in item.imgs" :key="index + img" class="swiper-slide">
                  <img v-if="isImageOrVideo(img) === 'image'" :src="img" style="width: 100%"/>
                  <video v-if="isImageOrVideo(img) === 'video'" :src="img" controls style="width: 100%"></video>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div class="mItemBottom">
              <div>
                <img v-if="item.avatarUrl"
                     :src="item.avatarUrl"
                     class="mItemBottomPic"
                />
              </div>

              <div class="mItemBottomRight">
                <div class="mItemBottomName">
                  {{ item.pddName || '' }}
                </div>
                <div class="mItemBottomTime">{{ item.updateDatetime || '' }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div v-if="listData.length === total">
        <div class="noMore">没有更多数据了~</div>
      </div>
    </div>

    <el-row class="rowBottom">
      <el-button
          icon="el-icon-back"
          size="small"
          type="danger"
          @click="handlePrev"
      >返回查单
      </el-button
      >
      <!--      <el-col :span="12">-->
      <!--        <div class="colHeadItem">-->
      <!--          <el-button-->
      <!--              icon="el-icon-more"-->
      <!--              size="small"-->
      <!--              type="primary"-->
      <!--              @click="handleNext"-->
      <!--          >加载更多-->
      <!--          </el-button-->
      <!--          >-->
      <!--        </div>-->
      <!--      </el-col>-->
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import {Loading, Message} from "element-ui";
import t from "../../assets/template.png";

// 节流
function _throttle(fn, delay = 50, that) {
  var lastTime, timer, delay;
  return function () {
    var _this = this;
    var args = arguments;
    var nowTime = Date.now();
    if (lastTime && nowTime - lastTime < delay) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        lastTime = nowTime;
        fn.apply(_this, args);
      }, delay);
    } else {
      lastTime = nowTime;
      fn.apply(_this, args);
    }
  };
}

export default {
  data() {
    return {
      activeName: "a",
      total: 0,
      t,
      query: {
        //  20250906212335205 20250906124651992
        id: "20250906212335205",
      },
      listData: [],
      currentItem: "",
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.query.id = this.$route.query.id;
    }
    this.getData();
    // this.$refs.box.addEventListener("scroll", _throttle(this.lazyLoading, 50));
  },
  methods: {
    // 滚动加载
    // lazyLoading(e) {
    //   const scrollTop = e.target.scrollTop;
    //   const windowHeight = e.target.clientHeight;
    //   const scrollHeight = e.target.scrollHeight;
    // },
    handleTabClick() {
    },
    handlePrev() {
      this.$router.back();
    },
    getData() {
      this.loading = Loading.service({
        fullscreen: true,
        text: "数据加载中...",
      });

      axios
          .get("https://api2.xn--nfvr38cjgq.cn/api2.php", {
            params: this.query,
          })
          .then((res) => {
            if (res.data.data.length === 0) {
              this.loading.close();
              return;
            }
            let data = JSON.parse(JSON.stringify(res.data.data));
            this.listData = data.map((item, index) => {
              return {
                imgs: item?.imageUrl?.split(','),
                ...item
              }
            })
            this.total = this.listData?.length || 0;
            this.$nextTick(() => {
              new Swiper(".swiperBox", {
                autoplay: {
                  disableOnInteraction: false,
                  delay: 2500,
                },
                pagination: {
                  el: ".swiper-pagination",
                },
              });
            });
            this.loading.close();
          })
          .catch(() => {
            this.loading.close();
          });
    },

    isImageOrVideo(filePath) {
      const ext = filePath.split('.').pop().toLowerCase();
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv'];
      if (imageExtensions.includes(ext)) {
        return 'image';
      } else if (videoExtensions.includes(ext)) {
        return 'video';
      } else {
        return 'unknown';
      }
    }
  },

  destroyed() {
  },
};
</script>

<style scoped>
@import url("./imgList.css");
</style>